import CommonForm from "../CommonComponent/CommonForm";

const PayEmi = () => {
  const fields = [
    {
      name: "Loan ID",
      inputPlaceholder: "Enter Loan ID",
    },
    {
      name: "Mobile Number",
      inputPlaceholder: "Enter Mobile NUmber",
    },
  ];
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CommonForm
        fields={fields}
        heading={"Enter Credentials"}
        buttonName="Fetch Details"
      />
    </div>
  );
};

export default PayEmi;
